const testimonialsData = [
  {
    id: 1,
    name: "Valentina Reyes",
    role: "Directora de Marketing en Aurora Skincare",
    quote:
      "Studio Form entendió nuestra marca desde el primer día. El resultado superó todas nuestras expectativas.",
    imgSrc: "https://i.pravatar.cc/150?img=1",
  },
  {
    id: 2,
    name: "Martín Delgado",
    role: "CEO en Nova Arquitectos",
    quote:
      "Nuestro sitio web pasó de ser una página más a convertirse en nuestra mejor herramienta de ventas.",
    imgSrc: "https://i.pravatar.cc/150?img=3",
  },
  {
    id: 3,
    name: "Camila Torres",
    role: "Brand Manager en Viento Coffee",
    quote:
      "El contenido para redes que crearon triplicó nuestro engagement en menos de tres meses. Impecables.",
    imgSrc: "https://i.pravatar.cc/150?img=5",
  },
  {
    id: 4,
    name: "Santiago Herrera",
    role: "Editor en Revista Pulso",
    quote:
      "Profesionales, creativos y con un ojo editorial increíble. La revista nunca se vio tan bien.",
    imgSrc: "https://i.pravatar.cc/150?img=8",
  },
  {
    id: 5,
    name: "Lucía Fernández",
    role: "Fundadora de Terra Orgánica",
    quote:
      "El packaging que diseñaron comunica exactamente lo que somos: naturales, honestos y premium.",
    imgSrc: "https://i.pravatar.cc/150?img=9",
  },
  {
    id: 6,
    name: "Diego Ramírez",
    role: "Product Lead en Lumina Fintech",
    quote:
      "Rediseñaron nuestra app y la tasa de retención subió un 40%. Datos que hablan por sí solos.",
    imgSrc: "https://i.pravatar.cc/150?img=11",
  },
  {
    id: 7,
    name: "Andrea Morales",
    role: "Directora Creativa en Estudio Raíz",
    quote:
      "Colaborar con Studio Form es un placer. Entienden el brief, proponen mejor y entregan a tiempo.",
    imgSrc: "https://i.pravatar.cc/150?img=16",
  },
];

export default testimonialsData;
